import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { jobsEndpoint } from "../constants";

const CreateOffer = () => {
  const { jobId, applicantId } = useParams();
  const [applicant, setApplicant] = useState(null);
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const token = localStorage.getItem("token")
  const [offerData, setOfferData] = useState({
    income: "",
    contract_type: "PERMANENT",
    location_type: "OFFICE",
    bonus: "",
    expire_date: "",
    notes: ""
  });
  const navigate = useNavigate();
  console.log(jobId)
  console.log(applicantId)

  useEffect(() => {
    const fetchData = async () => {
      try {
        
        // Fetch applicant details
        const applicantResponse = await axios.get(`${jobsEndpoint}applicant_details/${applicantId}`, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          }
        });
        setApplicant(applicantResponse.data);
        
        // Fetch job details
        const jobResponse = await axios.get(`${jobsEndpoint}${jobId}/`, {
          headers: {
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json',
          }
        });
        setJob(jobResponse.data);
        
      } catch (err) {
        setError("Failed to load applicant or job details.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (jobId && applicantId) {
      fetchData();
    }
  }, [jobId, applicantId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOfferData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!offerData.income) {
      setError("Please fill in all required fields.");
      return;
    }

    try {
      setSubmitting(true);
      setError(null);

      const payload = {
        job: jobId,
        recipient: applicantId,
        sender: applicant.user.id, // You might want to change this to the current user's ID
        income: parseInt(offerData.income),
        contract_type: offerData.contract_type,
        location_type: offerData.location_type,
        bonus: offerData.bonus,
        expire_date: offerData.expire_date || null,
        notes: offerData.notes,
      };

      await axios.post(`${jobsEndpoint}${jobId}/offer_create/`, payload, {
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        }
      });
      
      // Navigate back to applicants list or offers list
      navigate(`/applicants/${jobId}`);
      
    } catch (err) {
      setError("Failed to create offer. Please try again.");
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/applicants/${jobId}`);
  };

  if (loading) {
    return (
      <div className="lg:p-8">
        <p className="text-gray-500">Loading...</p>
      </div>
    );
  }

  if (error && !applicant) {
    return (
      <div className="lg:p-8">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  return (
    <div className="lg:p-8">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-2">
          <span 
            onClick={() => navigate("/jobs")}
            className="hover:text-gray-700 cursor-pointer"
          >
            Jobs
          </span>
          <span>›</span>
          <span 
            onClick={() => navigate(`/applicants/${jobId}`)}
            className="hover:text-gray-700 cursor-pointer"
          >
            Applicants
          </span>
          <span>›</span>
          <span className="text-gray-900">Create Offer</span>
        </div>
        <h1 className="text-2xl font-semibold text-gray-900">Create Job Offer</h1>
        <p className="mt-1 text-sm text-gray-600">
          Create an offer for {applicant?.user?.first_name} {applicant?.user?.last_name}
        </p>
      </div>

      {/* Applicant & Job Info */}
      <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Offer Details</h3>
        
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-2">Job Position</h4>
            <p className="text-sm text-gray-600">{job?.title}</p>
            <p className="text-xs text-gray-500">{job?.company}</p>
          </div>
          
          <div>
            <h4 className="font-medium text-gray-900 mb-2">Candidate</h4>
            <p className="text-sm text-gray-600">
              {applicant?.user?.first_name} {applicant?.user?.last_name}
            </p>
            <p className="text-xs text-gray-500">{applicant?.user?.email}</p>
          </div>
        </div>
      </div>

      {/* Offer Form */}
      <div className="bg-white rounded-xl border border-gray-200">
        <div className="p-6 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Offer Information</h3>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="text-red-600 text-sm">{error}</p>
            </div>
          )}

          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="income" className="block text-sm font-medium text-gray-700 mb-2">
                Salary/Income *
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">£</span>
                <input
                  type="number"
                  id="income"
                  name="income"
                  value={offerData.income}
                  onChange={handleInputChange}
                  placeholder="50000"
                  className="w-full pl-8 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#19bfb7] focus:border-transparent text-gray-900 placeholder-gray-400"
                  required
                />
              </div>
              <p className="text-xs text-gray-500 mt-1">Annual salary in GBP</p>
            </div>

            <div>
              <label htmlFor="contract_type" className="block text-sm font-medium text-gray-700 mb-2">
                Contract Type *
              </label>
              <select
                id="contract_type"
                name="contract_type"
                value={offerData.contract_type}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#19bfb7] focus:border-transparent text-gray-900"
                required
              >
                <option value="PERMANENT">Permanent</option>
                <option value="FIXED">Fixed Term</option>
                <option value="TEMPORARY">Temporary</option>
                <option value="FREELANCE">Freelance</option>
              </select>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="location_type" className="block text-sm font-medium text-gray-700 mb-2">
                Location Type *
              </label>
              <select
                id="location_type"
                name="location_type"
                value={offerData.location_type}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#19bfb7] focus:border-transparent text-gray-900"
                required
              >
                <option value="OFFICE">Office</option>
                <option value="REMOTE">Remote</option>
                <option value="HYBRID">Hybrid</option>
              </select>
            </div>

            <div>
              <label htmlFor="bonus" className="block text-sm font-medium text-gray-700 mb-2">
                Bonus Information
              </label>
              <input
                type="text"
                id="bonus"
                name="bonus"
                value={offerData.bonus}
                onChange={handleInputChange}
                placeholder="e.g., Annual bonus up to 10%"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#19bfb7] focus:border-transparent text-gray-900 placeholder-gray-400"
              />
            </div>
          </div>

          <div>
            <label htmlFor="expire_date" className="block text-sm font-medium text-gray-700 mb-2">
              Offer Expiry Date
            </label>
            <input
              type="datetime-local"
              id="expire_date"
              name="expire_date"
              value={offerData.expire_date}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#19bfb7] focus:border-transparent text-gray-900"
            />
            <p className="text-xs text-gray-500 mt-1">When should this offer expire?</p>
          </div>

          <div>
            <label htmlFor="notes" className="block text-sm font-medium text-gray-700 mb-2">
              Additional Notes
            </label>
            <textarea
              id="notes"
              name="notes"
              value={offerData.notes}
              onChange={handleInputChange}
              rows={4}
              placeholder="Enter any additional details about the offer, benefits, start date, etc."
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#19bfb7] focus:border-transparent resize-none text-gray-900 placeholder-gray-400"
            />
          </div>

          <div className="flex items-center gap-4 pt-4">
            <button
              type="submit"
              disabled={submitting}
              className="px-6 py-2 text-white bg-[#19bfb7] rounded-lg hover:bg-[#18ada6] disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitting ? "Creating Offer..." : "Create Offer"}
            </button>
            <button
              type="button"
              onClick={handleCancel}
              className="px-6 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateOffer;